import CommonIFrame from '../atoms/CommonIFrame';

const Alert = () => {
    return <CommonIFrame src="https://preview--open-page-orchestra.lovable.app/dashboard" title="Alert" />;
};

export default Alert;
